import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const offerApi = createApi({
  reducerPath: "offerApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["Offer"],
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;

        return {
          url: `offers?${new URLSearchParams(query).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Offer"],
    }),
    getOffer: builder.query({
      query: (id) => ({
        url: `offers/${id}`,
        method: "GET",
      }),
      providesTags: ["Offer"],
    }),
    createOffer: builder.mutation({
      query: (body) => ({
        url: "offers",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Offer"],
    }),
    updateOffer: builder.mutation({
      query: (body) => ({
        url: `offers/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Offer"],
    }),
    deleteOffer: builder.mutation({
      query: (id) => ({
        url: `offers/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Offer"],
    }),
  }),
});

export const {
  useGetOffersQuery,
  useGetOfferQuery,
  useCreateOfferMutation,
  useUpdateOfferMutation,
  useDeleteOfferMutation,
} = offerApi;
